import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta(
    "页面未找到 - 色戒未删减版",
    "你访问的页面不存在，可以返回首页或前往电影分类页浏览《色戒》完整版相关资料。",
    "色戒未删减版,页面未找到",
  );

  return (
    <SiteLayout>
      <section className="relative flex min-h-[78vh] items-center overflow-hidden pt-[72px]">
        <img
          src="https://readdy.ai/api/search-image?query=Empty%20dark%20cinema%20screen%20in%20an%20old%20theater%20with%20deep%20crimson%20curtains%20partially%20open%2C%20single%20dim%20spotlight%2C%20dust%20in%20the%20air%2C%20wooden%20stage%20floor%2C%20moody%20atmospheric%20photography%2C%20rich%20shadows%2C%20warm%20amber%20highlights%2C%20no%20text&width=1920&height=900&seq=sejie-404-bg-01&orientation=landscape"
          alt="空旷的老影院放映厅"
          title="页面未找到 - 色戒未删减版"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950 via-background-950/90 to-background-950/50" />
        <div className="relative z-10 mx-auto w-full max-w-[1180px] px-4 py-16 md:px-8">
          <p className="font-label text-[11px] uppercase tracking-[0.3em] text-accent-400">
            Error 404
          </p>
          <h1 className="mt-4 font-heading text-[34px] leading-tight text-foreground-50 md:text-[52px]">
            这场放映没有对应的片目
          </h1>
          <p className="mt-4 max-w-lg text-sm leading-[1.95] text-foreground-400">
            你访问的页面可能已被移动或从未存在。回到首页，或去分类页看看现有的资料与解析。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm text-foreground-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/category"
              className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-50/25 bg-background-950/40 px-6 text-sm text-foreground-100 transition-colors hover:border-accent-500/60 hover:text-accent-300"
            >
              浏览资料分类
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}